import { evaluateConditionalObj } from "lib/utils/conditionals"
import { parseContent } from "../../renderers/utils"


export const runConditionalLogic = (statements:any[], renderPkg:any) => {
  console.log(statements)
  const newContent: any[] = [];
  let conditionalReports: any[] = [];

  statements.filter((st:any) => st.visible === true).forEach((statement: any, idx: number) => {
    // console.log(renderPkg.clientdata)
    if (statement.conditional === null || statement.conditional === undefined) {
      if (statement.content.pass?.length) {
        const parsedContent = parseContent({ content: statement.content.pass, clientDataObj: renderPkg.clientdata, apiData: renderPkg.apidata }).result;
        newContent.push({ refstr: statement.refstr, content: parsedContent });
      }
    } else {
      const report = evaluateConditionalObj(statement.conditional, renderPkg.clientdata);
      conditionalReports.push({ statement: statement.refstr, report });

      if (report.verdict === true && statement.content.pass?.length) {
        const parsedContent = parseContent({ content: statement.content.pass, clientDataObj: renderPkg.clientdata, apiData: renderPkg.apidata }).result;
        newContent.push({ refstr: statement.refstr, content: parsedContent });
      }
      else if (report.verdict === false && statement.content.fail?.length) {
        const parsedContent = parseContent({ content: statement.content.fail, clientDataObj: renderPkg.clientdata, apiData: renderPkg.apidata }).result;
        newContent.push({ refstr: statement.refstr, content: parsedContent });
      }
    }
  });

  return { newContent, conditionalReports }
}